var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LegacyGrid',{attrs:{"title":_vm.SR_FieldRecordSystem.OperatingResources,"data":_vm.quantities,"columns":_vm.columns,"selection":"none"}})}
var staticRenderFns = []

export { render, staticRenderFns }